import React from 'react';
import { COLORS, Color } from '../../styles/variables';

interface BackIconProps {
  size?: number;
  color?: Color;
}

const BackIcon: React.FC<BackIconProps> = ({ color = COLORS.black, size = 24 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14 16.9L8.5 11.5 14 6.1"
      stroke={color}
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    />
  </svg>
);

export default BackIcon;
